module.exports = __webpack_public_path__ + "static/media/synthetix.fe836a87.svg";